module.exports = __webpack_public_path__ + "static/jira-e9eb85ee9ba461db3047d9f2420de58b.svg";